/* Форма входа — общая для всех вариантов экрана входа. Цвета из
   токенов темы: форма лежит на фоне темы или на карточке. */

.form {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 340px;
}

.heading {
  margin: 0 0 6px;
  font-size: 26px;
  font-weight: 650;
  line-height: 1.2;
  color: var(--text);
}

.note {
  margin: 0 0 22px;
  font-size: 14px;
  color: var(--text2);
}

.primary,
.secondary {
  width: 100%;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  border-radius: var(--r-md);
  cursor: pointer;
  transition:
    background 0.15s,
    border-color 0.15s;
}

.primary {
  color: #fff;
  background: var(--blue);
  border: 1px solid var(--blue);
}

.primary:hover:not(:disabled) {
  background: var(--blue-dark);
  border-color: var(--blue-dark);
}

.secondary {
  margin-top: 4px;
  color: var(--text);
  background: var(--card-bg);
  border: 1px solid var(--border);
}

.secondary:hover:not(:disabled) {
  border-color: var(--slate-lt);
}

.primary:disabled,
.secondary:disabled {
  opacity: 0.65;
  cursor: default;
}

.error {
  margin-top: 14px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
  color: var(--err);
  background: var(--err-bg);
  border-radius: var(--r-sm);
}

/* Ссылка на служебный вход — намеренно неприметная: она нужна
   одной учётной записи, а остальным только мешала бы. */
.serviceToggle {
  align-self: flex-start;
  margin-top: 18px;
  padding: 2px 0;
  background: none;
  border: none;
  font-size: 13px;
  color: var(--text2);
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

.serviceToggle:hover {
  color: var(--text);
}

.service {
  margin-top: 16px;
  padding-top: 18px;
  border-top: 1px solid var(--border);
}

.plain {
  margin-top: 18px;
}

.serviceNote {
  margin: 0 0 16px;
  font-size: 12.5px;
  color: var(--text2);
}

.field {
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
}

.label {
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text2);
}

.input {
  padding: 11px 12px;
  font-size: 15px;
  color: var(--text);
  background: var(--input-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
}

.input:focus {
  outline: none;
  border-color: var(--blue);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--blue) 22%, transparent);
}

@media (max-width: 860px) {
  .form {
    max-width: 420px;
  }
}
